/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _defineProperty = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.style = exports.name = exports.mapDispatchToProps = exports.mapStateToProps = exports.Render = void 0;

var react_1 = __importDefault(require("react"));

var brightsmith_core_1 = require("brightsmith-core");

var brightsmith_redux_1 = require("brightsmith-redux");

var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");

var icon_close_png_1 = __importDefault(require("./assets/icon-close.png"));

var RenderHelper_1 = __importDefault(require("./helpers/RenderHelper"));

var utils_1 = require("./utils");

var BrightsmithDb = brightsmith_core_1.Db.BrightsmithDb;
var name = 'Render';
exports.name = name;

var Render = function Render(_ref) {
  var Frame = _ref.Frame,
      Canvas = _ref.Canvas,
      Icon = _ref.Icon,
      Image = _ref.Image,
      Text = _ref.Text,
      styles = _ref.styles,
      theme = _ref.theme;
  return /*#__PURE__*/function (_react_1$default$Pure) {
    _inherits(_class, _react_1$default$Pure);

    var _super = _createSuper(_class);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _super.call(this, props);
      _this.state = {
        isLoading: true
      };
      _this.handleClickFullScreen = _this.handleClickFullScreen.bind(_assertThisInitialized(_this));
      _this.renderViewArea = _this.renderViewArea.bind(_assertThisInitialized(_this));
      _this.setIsLoading = _this.setIsLoading.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(_class, [{
      key: "renderViewArea",
      value: function renderViewArea(props) {
        var _a, _b, _c, _d, _e, _f;

        var activeView = props.activeView,
            classes = props.classes,
            env = props.env,
            fullScreen = props.fullScreen,
            model = props.model,
            opts = props.opts,
            properties = props.properties;
        var urls = RenderHelper_1.default.getUrls(env, activeView, model, properties);
        var height = ((_a = model === null || model === void 0 ? void 0 : model.display) === null || _a === void 0 ? void 0 : _a.height) || ((_b = theme === null || theme === void 0 ? void 0 : theme.Render) === null || _b === void 0 ? void 0 : _b.height);
        var width = ((_c = model === null || model === void 0 ? void 0 : model.display) === null || _c === void 0 ? void 0 : _c.width) || ((_d = theme === null || theme === void 0 ? void 0 : theme.Render) === null || _d === void 0 ? void 0 : _d.width);
        var scale = ((_e = model === null || model === void 0 ? void 0 : model.display) === null || _e === void 0 ? void 0 : _e.scale) || ((_f = theme === null || theme === void 0 ? void 0 : theme.Render) === null || _f === void 0 ? void 0 : _f.scale) || 1;

        switch (props.type) {
          case 'canvas':
          default:
            return react_1.default.createElement(Canvas, Object.assign({}, opts, {
              className: [classes === null || classes === void 0 ? void 0 : classes.drawArea],
              containerCls: [classes === null || classes === void 0 ? void 0 : classes.canvasContainer],
              magnifierCls: [classes === null || classes === void 0 ? void 0 : classes.magnifier],
              height: height * scale,
              isFullScreen: fullScreen,
              setIsLoading: this.setIsLoading,
              urls: urls,
              width: width * scale,
              style: styles === null || styles === void 0 ? void 0 : styles.drawArea
            }));
        }
      }
    }, {
      key: "handleClickFullScreen",
      value: function handleClickFullScreen() {
        var _this$props = this.props,
            fullScreen = _this$props.fullScreen,
            setFullScreen = _this$props.setFullScreen;
        setFullScreen(!fullScreen);
      }
    }, {
      key: "setIsLoading",
      value: function setIsLoading(isLoading) {
        this.setState({
          isLoading: isLoading
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            after = _this$props2.after,
            before = _this$props2.before,
            classes = _this$props2.classes,
            controls = _this$props2.controls,
            fullScreen = _this$props2.fullScreen,
            hasLoaded = _this$props2.hasLoaded,
            Loading = _this$props2.Loading,
            model = _this$props2.model,
            opts = _this$props2.opts;
        var isLoading = this.state.isLoading;
        var showTitle = (opts === null || opts === void 0 ? void 0 : opts.title) && (model === null || model === void 0 ? void 0 : model.name);
        return react_1.default.createElement(Frame, {
          className: ['Render__container', classes === null || classes === void 0 ? void 0 : classes.container, _defineProperty({}, (classes === null || classes === void 0 ? void 0 : classes.fullScreen) || '', fullScreen)]
        }, before, react_1.default.createElement(Frame, {
          className: ['Render__inner', classes === null || classes === void 0 ? void 0 : classes.inner],
          style: styles === null || styles === void 0 ? void 0 : styles.inner
        }, fullScreen && react_1.default.createElement(Image, {
          className: ['Render__fullScreenCloseButton', classes === null || classes === void 0 ? void 0 : classes.fullScreenCloseButton],
          src: icon_close_png_1.default,
          onClick: this.handleClickFullScreen
        }), showTitle && react_1.default.createElement(Text, {
          className: ['Render__title', classes === null || classes === void 0 ? void 0 : classes.title],
          style: styles === null || styles === void 0 ? void 0 : styles.title
        }, model === null || model === void 0 ? void 0 : model.name), react_1.default.createElement(Frame, {
          className: ['Render__drawAreaContainer', classes === null || classes === void 0 ? void 0 : classes.drawAreaContainer, _defineProperty({}, (classes === null || classes === void 0 ? void 0 : classes.drawAreaContainerMax) || '', fullScreen)],
          styles: styles === null || styles === void 0 ? void 0 : styles.drawAreaContainer
        }, hasLoaded && this.renderViewArea(this.props), isLoading && Loading), controls, (opts === null || opts === void 0 ? void 0 : opts.fullScreen) && !fullScreen && react_1.default.createElement(Frame, {
          className: ['Render__fullScreen', classes === null || classes === void 0 ? void 0 : classes.textFullScreen],
          onClick: this.handleClickFullScreen,
          style: styles === null || styles === void 0 ? void 0 : styles.textFullScreen
        }, react_1.default.createElement(Icon, {
          className: ['Render__fullScreenIcon', classes === null || classes === void 0 ? void 0 : classes.fullScreenButton],
          icon: free_solid_svg_icons_1.faExpand
        }), react_1.default.createElement(Text, {
          className: ['Render__fullScreenButtonText', classes === null || classes === void 0 ? void 0 : classes.fullScreenButtonText]
        }, "Full Screen View"))), after);
      }
    }]);

    return _class;
  }(react_1.default.PureComponent);
};

exports.Render = Render;
var mapDispatchToProps = {
  setFullScreen: brightsmith_redux_1.Actions.Ui.setFullScreen
};
exports.mapDispatchToProps = mapDispatchToProps;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var api = state.api,
      ui = state.ui;
  var configuration = api.configuration,
      hasLoaded = api.hasLoaded;
  var activeView = ui.activeView,
      fullScreen = ui.fullScreen;
  var db = new BrightsmithDb(api);
  var model = db.getCurrentModel();
  var properties = db.getPropertiesFromConfiguration(configuration);
  return {
    activeView: activeView,
    configuration: configuration,
    fullScreen: fullScreen,
    hasLoaded: hasLoaded,
    model: model,
    properties: properties
  };
};

exports.mapStateToProps = mapStateToProps;

var style = function style(theme) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2;

  return {
    container: Object.assign(_defineProperty({
      background: (_a = theme === null || theme === void 0 ? void 0 : theme.base) === null || _a === void 0 ? void 0 : _a.backgroundColor,
      display: 'flex',
      flex: 5,
      flexDirection: 'column',
      order: 2,
      padding: 15,
      position: 'relative'
    }, "@media (max-width: ".concat((_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.mobile, "px)"), {
      zIndex: 10
    }), (_c = theme === null || theme === void 0 ? void 0 : theme.Render) === null || _c === void 0 ? void 0 : _c.container),
    canvasContainer: Object.assign(_defineProperty({}, "@media (max-width: ".concat((_d = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _d === void 0 ? void 0 : _d.mobile, "px)"), {
      display: 'flex',
      alignItems: 'center'
    }), (_e = theme === null || theme === void 0 ? void 0 : theme.Render) === null || _e === void 0 ? void 0 : _e.canvasContainer),
    closeButton: Object.assign({
      height: 40,
      position: 'absolute',
      right: 0,
      paddingRight: 36,
      paddingTop: 36,
      width: 40
    }, (_f = theme === null || theme === void 0 ? void 0 : theme.Render) === null || _f === void 0 ? void 0 : _f.closeButton),
    controls: Object.assign({
      display: 'flex',
      flexDirection: 'row',
      marginTop: 15
    }, (_g = theme === null || theme === void 0 ? void 0 : theme.Render) === null || _g === void 0 ? void 0 : _g.controls),
    drawArea: Object.assign({
      maxWidth: '100%',
      width: (_h = theme.Render) === null || _h === void 0 ? void 0 : _h.width
    }, (_j = theme === null || theme === void 0 ? void 0 : theme.Render) === null || _j === void 0 ? void 0 : _j.drawArea),
    drawAreaContainer: Object.assign(_defineProperty({
      display: 'flex',
      justifyContent: 'center',
      height: '100%',
      maxHeight: '100%',
      position: 'relative'
    }, "@media (max-width: ".concat((_k = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _k === void 0 ? void 0 : _k.mobile, "px)"), {
      height: 150,
      maxHeight: 150
    }), (_l = theme === null || theme === void 0 ? void 0 : theme.Render) === null || _l === void 0 ? void 0 : _l.drawAreaContainer),
    drawAreaContainerMax: Object.assign(_defineProperty({}, "@media (max-width: ".concat((_m = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _m === void 0 ? void 0 : _m.mobile, "px)"), {
      height: '100%',
      maxHeight: '100%'
    }), (_o = theme === null || theme === void 0 ? void 0 : theme.Render) === null || _o === void 0 ? void 0 : _o.drawAreaContainerMax),
    fullScreen: Object.assign({
      backgroundColor: ((_p = theme === null || theme === void 0 ? void 0 : theme.base) === null || _p === void 0 ? void 0 : _p.backgroundColor) || '#fff',
      '@web': {
        '-webkit-overflow-scrolling': 'touch',
        bottom: 0,
        left: 0,
        position: 'fixed',
        right: 0,
        top: 0,
        zIndex: 100
      }
    }, (_q = theme === null || theme === void 0 ? void 0 : theme.Render) === null || _q === void 0 ? void 0 : _q.fullScreen),
    fullScreenButton: Object.assign(Object.assign(Object.assign({
      fontSize: 16
    }, utils_1.StyleUtils.margin('0 6px')), _defineProperty({}, "@media (max-width: ".concat((_r = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _r === void 0 ? void 0 : _r.mobile, "px)"), {})), (_s = theme === null || theme === void 0 ? void 0 : theme.Render) === null || _s === void 0 ? void 0 : _s.fullScreenButton),
    fullScreenButtonText: Object.assign(Object.assign(Object.assign({}, utils_1.StyleUtils.margin('0 6px')), _defineProperty({}, "@media (max-width: ".concat((_t = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _t === void 0 ? void 0 : _t.mobile, "px)"), {
      display: 'none'
    })), (_u = theme === null || theme === void 0 ? void 0 : theme.Render) === null || _u === void 0 ? void 0 : _u.fullScreenButtonText),
    fullScreenCloseButton: Object.assign({
      height: 40,
      position: 'absolute',
      right: 0,
      paddingRight: 40,
      paddingTop: 40,
      top: 0,
      width: 40,
      zIndex: 1,
      '&:hover': {
        cursor: 'pointer'
      }
    }, (_v = theme === null || theme === void 0 ? void 0 : theme.Render) === null || _v === void 0 ? void 0 : _v.fullScreenButtonText),
    inner: Object.assign(_defineProperty({
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      maxHeight: '100%',
      maxWidth: (_w = theme === null || theme === void 0 ? void 0 : theme.Body) === null || _w === void 0 ? void 0 : _w.maxWidth,
      width: '100%'
    }, "@media (max-width: ".concat((_x = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _x === void 0 ? void 0 : _x.mobile, "px)"), {
      justifyContent: 'center'
    }), (_y = theme === null || theme === void 0 ? void 0 : theme.Render) === null || _y === void 0 ? void 0 : _y.inner),
    magnifier: Object.assign({
      borderRadius: 75,
      boxShadow: '0px 3px 6px #00000029',
      display: 'none',
      left: 0,
      position: 'absolute',
      pointerEvents: 'none',
      top: 0
    }, (_z = theme === null || theme === void 0 ? void 0 : theme.Render) === null || _z === void 0 ? void 0 : _z.magnifier),
    textFullScreen: Object.assign({
      bottom: 20,
      cursor: 'pointer',
      fontSize: 12,
      fontWeight: '500',
      left: 15,
      position: 'absolute',
      textDecoration: 'underline',
      textTransform: 'uppercase',
      display: 'flex',
      alignItems: 'center'
    }, (_0 = theme === null || theme === void 0 ? void 0 : theme.Render) === null || _0 === void 0 ? void 0 : _0.textFullScreen),
    title: Object.assign(Object.assign(Object.assign({
      alignSelf: 'flex-start',
      fontFamily: 'Roboto',
      fontSize: 36,
      fontWeight: '300'
    }, (_1 = theme === null || theme === void 0 ? void 0 : theme.Render) === null || _1 === void 0 ? void 0 : _1.title), {
      '@mobile': {
        fontSize: 26
      }
    }), (_2 = theme === null || theme === void 0 ? void 0 : theme.Render) === null || _2 === void 0 ? void 0 : _2.fullScreenButtonText)
  };
};

exports.style = style;